import type { FormaRent } from '../core/FormaRent';

/**
 * Слушает FORMA_CLOSE от iframe (booking-страница) и закрывает модалку.
 * Закрытие инициируется через внутреннюю кнопку на booking-странице, не через
 * кнопку виджета (см. архитектурное решение: close визуально внутри формы).
 */
export function installCloseBridge(instance: FormaRent): () => void {
  const cfg = instance._config;
  if (!cfg) return () => {};
  // Извлекаем строгий origin (scheme+host+port) — baseUrl может содержать path/query,
  // а e.origin — только origin, иначе сравнение будет ломаться.
  const formaOrigin = new URL(cfg.baseUrl ?? __FORMA_ORIGIN__).origin;

  const handler = (e: MessageEvent): void => {
    if (e.origin !== formaOrigin) return;
    // Fail-closed: если iframe ещё не смонтирован, отклоняем любое FORMA_CLOSE
    // (иначе same-origin источник типа другого iframe смог бы послать событие
    // до полной инициализации и закрыть модалку).
    const iframe = instance._getIframe();
    if (!iframe || e.source !== iframe.contentWindow) return;

    const raw: unknown = e.data;
    if (!raw || typeof raw !== 'object') return;
    if ((raw as { type?: unknown }).type !== 'FORMA_CLOSE') return;
    if (!instance.isOpen) return;

    instance.close();
  };

  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
}
